import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const LightningIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="currentColor">
    <path d="M13 2L4 14h6l-2 8 9-12h-6l2-8z" />
  </svg>
)
